import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import PanToolIcon from '@material-ui/icons/PanTool'
import GradientButton from 'components/common/GradientButton'
import api from 'utils/api'
import { useSnackbar } from 'notistack'

const useStyles = makeStyles(theme => ({
	leftIcon: {
		fontSize: 20,
		marginRight: theme.spacing(1),
	},
}))

function SendClapButton() {
	const classes = useStyles()
	const { enqueueSnackbar } = useSnackbar()
	const [isSubmitting, setIsSubmitting] = useState(false)

	async function sendClap() {
		setIsSubmitting(true)
		try {
			const { data } = await api.post('/api/message.php', { type: 'clap' })
			enqueueSnackbar(data.message, { variant: 'success' })
		} catch (e) {
			enqueueSnackbar(e.response.data.message || '박수를 보낼 수 없습니다.', { variant: 'error' })
		} finally {
			setIsSubmitting(false)
		}
	}

	return (
		<GradientButton variant="contained" color="primary" size="large" onClick={sendClap} disabled={isSubmitting}>
			<PanToolIcon className={classes.leftIcon} />
			박수를 보낸다
		</GradientButton>
	)
}

export default SendClapButton
